import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { IMG } from "@/data/projects";

const values = [
  { n: "01", t: "Persoonlijke opname", b: "Wij komen bij u langs, meten in en denken mee over de beste oplossing." },
  { n: "02", t: "Productie op maat", b: "Uw kozijnen worden nauwkeurig en op maat geproduceerd." },
  { n: "03", t: "Vakkundige montage", b: "Eigen ervaren monteurs plaatsen alles strak en netjes." },
  { n: "04", t: "Oplevering & garantie", b: "Wij ruimen op, controleren alles en geven ruime garantie." },
];

export default function Over() {
  return (
    <main data-testid="over-page" className="bg-white">
      <Seo
        title="Over DEKO Kozijnen | Eigen monteurs & 15 jaar garantie"
        description="Maak kennis met DEKO Kozijnen: vakmanschap uit Noord-Nederland. Persoonlijke opname, productie op maat, montage door eigen monteurs en 15 jaar garantie."
      />
      <section className="pt-40 pb-16 mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <Reveal className="lg:col-span-7">
          <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Over DEKO</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-6xl text-[#2F3438] mt-5 leading-tight">Kwaliteit boven prijs. Altijd.</h1>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-[#222]/60 text-lg font-light leading-relaxed">
            DEKO Kozijnen is een Noord-Nederlands bedrijf gespecialiseerd in hoogwaardige kunststof kozijnen, deuren en schuifpuien. Wij geloven dat echt vakmanschap zich laat zien in de details.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <div className="overflow-hidden rounded-sm aspect-[21/9]">
            <img src={IMG.darkFacade} alt="Moderne architectuur met antraciet kozijnen" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="py-24 md:py-32 mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal><h2 className="font-display font-bold text-3xl sm:text-4xl text-[#2F3438] max-w-xl">Zo werken wij.</h2></Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#ECECEA] border border-[#ECECEA]">
          {values.map((v, i) => (
            <Reveal key={v.n} delay={i * 0.08} className="bg-white p-10 min-h-[240px] flex flex-col justify-between">
              <span className="font-display font-extrabold text-5xl text-[#2F3438]/10">{v.n}</span>
              <div>
                <h3 className="font-display font-semibold text-xl text-[#2F3438]">{v.t}</h3>
                <p className="text-[#222]/55 mt-2 font-light">{v.b}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#2F3438] text-white py-24 text-center">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          <Reveal>
            <p className="font-display font-bold text-3xl sm:text-5xl leading-tight max-w-3xl mx-auto">Kwaliteit waar je op kunt bouwen.</p>
            <Link to="/offerte" data-testid="over-offerte-cta" className="group inline-flex items-center gap-3 mt-10 bg-white text-[#2F3438] px-8 py-4 rounded-sm hover:bg-white/90 transition-colors duration-300">
              <span className="text-sm font-medium">Vraag vrijblijvend een offerte aan</span>
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
